import { composeWithDevTools } from '@redux-devtools/extension';
import { AnyAction, applyMiddleware, createStore, Store } from 'redux';
import thunk from 'redux-thunk';

import api, { MiddlewareAction } from './middleware/api.js';
import rootReducer from './reducer/index.js';

const configureStore = () => {
  const store = createStore(
    rootReducer,
    composeWithDevTools(applyMiddleware(thunk, api)),
  );

  return store;
};

const store: Store = configureStore();

export interface AppDispatch {
  (action: MiddlewareAction): Promise<any>;
  (action: AnyAction): AnyAction;
}

export default store;
